import type { ReactNode } from 'react'

export interface FormFieldProps {
  children: ReactNode
  error?: string
  errorDisplay?: 'sr-only' | 'visible'
  errorRole?: 'alert'
  hint?: string
  htmlFor?: string
  label: string
  labelExtra?: ReactNode
  required?: boolean
}

export function FormField({
  children,
  error,
  errorDisplay = 'visible',
  errorRole,
  hint,
  htmlFor,
  label,
  labelExtra,
  required = false,
}: FormFieldProps) {
  const description = error ?? hint

  return (
    <div className="grid gap-[6px]">
      <div className="inline-flex w-fit items-center gap-1">
        <label className="text-sm font-semibold text-[var(--color-text)]" htmlFor={htmlFor}>
          {label}
          {required ? <span className="ml-1 text-[var(--color-danger)]">*</span> : null}
        </label>
        {labelExtra}
      </div>
      {children}
      {description ? (
        <p
          className={
            error && errorDisplay === 'sr-only'
              ? 'sr-only'
              : error
                ? 'text-sm text-[var(--color-danger)]'
                : 'text-sm text-[var(--color-text-muted)]'
          }
          role={error ? errorRole : undefined}
        >
          {description}
        </p>
      ) : null}
    </div>
  )
}
